export type ReactionType =
  | 'skinReactions'
  | 'localReactions'
  | 'generalReactions'
  | 'allergicReactions'
  | 'respiratoryReactions'
  | 'cardiovascularReactions';

export type Reaction = {
  code: string;
  ru: string;
  en: string;
  type?: ReactionType;
  isCategory?: boolean;
};

export const REACTION_TYPE_COLORS: Record<ReactionType, string> = {
  skinReactions: '#e3f2fd', // Light Blue
  localReactions: '#e8f5e9', // Light Green
  generalReactions: '#fff3e0', // Light Orange
  allergicReactions: '#fce4ec', // Light Pink
  respiratoryReactions: '#f3e5f5', // Light Purple
  cardiovascularReactions: '#ffebee', // Light Red
};

export const REACTION_TYPE_LABELS: Record<ReactionType, { ru: string; en: string }> = {
  skinReactions: { ru: 'Кожные реакции', en: 'Skin reactions' },
  localReactions: { ru: 'Местные реакции', en: 'Local reactions' },
  generalReactions: { ru: 'Общие реакции', en: 'General reactions' },
  allergicReactions: { ru: 'Аллергические реакции', en: 'Allergic reactions' },
  respiratoryReactions: { ru: 'Респираторные реакции', en: 'Respiratory reactions' },
  cardiovascularReactions: { ru: 'Сердечно-сосудистые реакции', en: 'Cardiovascular reactions' },
};
